export const SEARCH_FORM_CLASSNAME = "js-transparent-account-list-form";
